import * as vertrieb from "./vertrieb";
import * as netzwirtschaft from "./netzwirtschaft";
import * as netzkunden from "./netzkunden";
import * as ar from "./ar";
import * as strategietag from "./strategietag";
import {
  buildEvaluationUserPrompt,
  buildKurzOvernightUserPrompt,
  buildOvernightUserPrompt,
} from "./common";
import type { RequirementFields } from "../types";

// Pro-Offsite-Auswahl der System-Prompts. Neue Offsites bekommen je eine
// eigene Datei und einen Eintrag hier.

const EVAL: Record<string, string> = {
  vertrieb: vertrieb.EVALUATION_SYSTEM_PROMPT,
  netzwirtschaft: netzwirtschaft.EVALUATION_SYSTEM_PROMPT,
  netzkunden: netzkunden.EVALUATION_SYSTEM_PROMPT,
  ar: ar.EVALUATION_SYSTEM_PROMPT,
  strategietag: strategietag.EVALUATION_SYSTEM_PROMPT,
};

const OVERNIGHT: Record<string, string> = {
  vertrieb: vertrieb.OVERNIGHT_SYSTEM_PROMPT,
  netzwirtschaft: netzwirtschaft.OVERNIGHT_SYSTEM_PROMPT,
  netzkunden: netzkunden.OVERNIGHT_SYSTEM_PROMPT,
  ar: ar.OVERNIGHT_SYSTEM_PROMPT,
  strategietag: strategietag.OVERNIGHT_SYSTEM_PROMPT,
};

// Welches Eingabeformular ein Offsite hat, entscheidet auch, wie der
// User-Prompt gebaut wird. Das gehört neben die System-Prompts und nicht als
// `if (OFFSITE_ID === "ar")` in den Lambda-Code.
type UserPromptBuilder = (fields: RequirementFields) => string;

const OVERNIGHT_USER: Record<string, UserPromptBuilder> = {
  vertrieb: buildOvernightUserPrompt,
  netzwirtschaft: netzwirtschaft.buildOvernightUserPrompt,
  netzkunden: buildOvernightUserPrompt,
  ar: buildKurzOvernightUserPrompt,
  // Strategietag nutzt dasselbe Kurzformular wie AR: Themenwahl statt
  // Langformular, siehe offsite.config.ts (Task 6).
  strategietag: buildKurzOvernightUserPrompt,
};

export function getEvaluationPrompt(key: string): string {
  const p = EVAL[key];
  if (!p) throw new Error(`Kein Evaluation-Prompt für Offsite "${key}"`);
  return p;
}

export function getOvernightPrompt(key: string): string {
  const p = OVERNIGHT[key];
  if (!p) throw new Error(`Kein Overnight-Prompt für Offsite "${key}"`);
  return p;
}

/** User-Prompt-Builder des Offsites (Langformular vs. AR-Kurzformular). */
export function getOvernightUserPromptBuilder(key: string): UserPromptBuilder {
  const b = OVERNIGHT_USER[key];
  if (!b) throw new Error(`Kein Overnight-User-Prompt für Offsite "${key}"`);
  return b;
}

type EvalUserPromptBuilder = (
  topicTitle: string,
  teamName: string | null,
  fields: RequirementFields,
) => string;

// Nur Offsites mit eigenem Formular brauchen einen eigenen Eintrag — alle
// anderen nutzen den generischen Builder aus common.ts.
const EVAL_USER: Record<string, EvalUserPromptBuilder> = {
  netzwirtschaft: netzwirtschaft.buildEvaluationUserPrompt,
};

/** User-Prompt-Builder der Bewertung; Standard ist das Langformular. */
export function getEvaluationUserPromptBuilder(key: string): EvalUserPromptBuilder {
  return EVAL_USER[key] ?? buildEvaluationUserPrompt;
}
